/**
 * Created by zzy on 2019/8/5.
 */
import VideoDiagnosisStatus from './VideoDiagnosisStatus.vue'
export default VideoDiagnosisStatus



// WEBPACK FOOTER //
// ./src/views/maintenance/videoDiagnosisStatus/index.js